import React, { Suspense, useState } from 'react'
import { Link } from 'react-router-dom'
import TabContext from '@mui/lab/TabContext'
import TabList from '@mui/lab/TabList'
import TabPanel from '@mui/lab/TabPanel'
import { Tab } from '@mui/material'
import PageLayoutV2 from 'common/Layout/Page/PageLayoutV2'

import LayoutSkeleton from '../../../../common/Skeletons/LayoutSkeleton'
import { FaberCustomerDashboard } from '../../components'
export default function FaberCustomerManagement() {
  const [tabValue, setTabValue] = useState('1')
  const handleTabChange = (event, newNum) => setTabValue(newNum)

  return (
    <Suspense fallback={<LayoutSkeleton />}>
      <PageLayoutV2 header={'Customers - Faber'}>
        <TabContext value={tabValue}>
          <TabList onChange={handleTabChange} aria-label='lab API tabs example'>
            <Tab label='Dashboard' value='1' component={Link} to='#dashboard' />
            <Tab
              label='Data Rollover'
              value='2'
              component={Link}
              to='#data-rollover'
            />
          </TabList>

          <TabPanel value='1'>
            <FaberCustomerDashboard tabValue={tabValue} />
          </TabPanel>
          <TabPanel value='2'>
            <FaberCustomerDashboard tabValue={tabValue} />
          </TabPanel>
        </TabContext>
      </PageLayoutV2>
    </Suspense>
  )
}
